module.exports = require("@epam/uui-core");